import GameSoundVars from "../../../game/src/enums/GameSoundVars";
import { State } from "../../core/src/states/State";
import ViewManager from "../../core/src/utils/ViewManager";
import JackpotsModel from "../../src/model/JackpotsModel";
import { Ease } from "../../core/src/Ease";
import GameModel from "../../core/src/model/GameModel";
import BangUp from "../../core/src/utils/BangUp";
import SoundController from "../../core/src/utils/SoundController";
import BitmapTextField from "../../core/src/views/components/BitmapTextField";
import TextField from "../../core/src/views/components/TextField";
import DragonBonesAnimation from "../../core/src/views/DragonBonesAnimation";
import { Text } from "pixi.js";

export default class JackpotWinState extends State {
    protected bwBitmapText: BitmapTextField | TextField | Text;
    private jackpotNames: Map<string, string[]> = new Map(
        [
            ["Mini", ["MINI", "JP_SMALL"]],
            ["Minor", ["MINOR", "JP_SMALL"]],
            ["Major", ["MAJOR", "JP_BIG"]],
            ["Grand", ["GRAND", "JP_BIG"]]
        ]);
    enter() {
        this.startJackpotWin();
        super.enter();
    };
    public async startJackpotWin() {
        ViewManager.getLayer("SplashOverlay").setScene("open");
        let backgroundscene = ViewManager.getLayer("Jackpot").setScene(`jackpotWin_${JackpotsModel.jackpotWonName}`);
        let jackAnim: DragonBonesAnimation = backgroundscene
            .dragonBones
            .get(`JACKPOT^${this.jackpotNames.get(JackpotsModel.jackpotWonName)[0]}_JACKPOT`);
        let coinsAnim: DragonBonesAnimation = backgroundscene.dragonBones.get("JACKPOT^COINS");
        SoundController.playSound(GameSoundVars[this.jackpotNames.get(JackpotsModel.jackpotWonName)[1]],false,null,true);

        const winMoney = backgroundscene.sceneMoneyFields.get("win_counter");

        let currentBangup = new BangUp();
        let bangUpVal = 0;
        currentBangup.startBangup(0, JackpotsModel.winAmount, GameModel.gameConfig.jackpotAnimDuration,
            { ease: Ease.None },
            (val) => {
                bangUpVal = val;
                winMoney.value = bangUpVal;
            },
            () => {
                // this.onBigWinAnimationComplete();
            });
            coinsAnim.displayObject.visible = false;
        await jackAnim.play("START", 1);
        jackAnim.play("LOOP", 1);
        coinsAnim.displayObject.visible = true;
        await coinsAnim.play("animation", 1);
        backgroundscene.destroy();
        this.exit();
    };


    exit() {
        JackpotsModel.winAmount = 0;
        ViewManager.getLayer("SplashOverlay").completeClear();
        ViewManager.getLayer("Jackpot").completeClear();
        super.exit();
    };
};
